import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import SydModal from '../../../../commonDesign/SydModal'
import SydInput from '../../../../commonDesign/SydInput'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydSelect from '../../../../commonDesign/SydSelect'
import SaveCancelButtons from '../../../../molecules/SaveCancelButtons'
import { useInvalidatePeopleSearch, useModifyPersonMutation } from '../../../../../api/people'
import ErrorDisplay from '../../../../molecules/ErrorDisplay'
import { usePersonTypeOptions } from './usePersonTypeOptions'

const EditPersonModal = ({ open, onClose, person }) => {
  const { data: personTypeOptions, isLoading } = usePersonTypeOptions()
  const queryCallback = useInvalidatePeopleSearch()
  const { mutateAsync: updatePerson, isLoading: isUpdating, error } = useModifyPersonMutation()
  const form = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      personTypeId: '',
      personId: 0
    }
  })
  useEffect(() => {
    if (person) {
      form.reset({
        firstName: person.firstName,
        lastName: person.lastName,
        email: person.email,
        personTypeId: person.personTypeId,
        personId: person.personId
      })
    }
  }, [person, form])
  const onSubmit = async (person) => {
    const { data } = await updatePerson(person)
    if (data.success) {
      queryCallback()
      onClose()
    }
  }
  return (
    <SydModal title='Edit Person' open={open} onClose={onClose}>
      <form className='form flex flex-col gap-md'>
        <div className='flex flex-row justify-between'>
          <Controller
            name='firstName'
            control={form.control}
            render={(f) => (
              <SydLabel label='First Name'>
                <SydInput {...f.field} />
              </SydLabel>
            )}
          />
          <Controller
            name='lastName'
            control={form.control}
            render={(f) => (
              <SydLabel label='Last Name'>
                <SydInput {...f.field} />
              </SydLabel>
            )}
          />
        </div>
        <div className='flex flex-row w-full'>
          <Controller
            name='email'
            control={form.control}
            render={(f) => (
              <SydLabel label='Email' className='w-full'>
                <SydInput {...f.field} />
              </SydLabel>
            )}
          />
        </div>
        {!isLoading &&
          <div className='flex flex-row'>
            <Controller
              name='personTypeId'
              control={form.control}
              render={(f) => (
                <SydLabel label='Person Type'>
                  <SydSelect {...f.field} options={personTypeOptions} />
                </SydLabel>
              )}
            />
          </div>}
        {
          error && (
            <div className='flex flex-row justify-center w-full'>
              <ErrorDisplay error={error?.toString()} />
            </div>
          )
        }
      </form>
      <div className='flex flex-row justify-center w-full'>
        <SaveCancelButtons onCancel={onClose} onSave={form.handleSubmit(onSubmit)} isSubmitting={isUpdating} />
      </div>
    </SydModal>
  )
}

EditPersonModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  person: PropTypes.object
}

export default EditPersonModal
